export interface OperationProgressRow {
  id: string;
  name: string;
  status: string;
  error?: string;
}

export function progressRowsAfterStreamError(
  prev: OperationProgressRow[],
  message: string,
): OperationProgressRow[] {
  const error = String(message || 'Operation failed').trim() || 'Operation failed';
  const next = prev.map((row) => {
    if (row.status === 'running' || row.status === 'resolving') {
      return { ...row, status: 'failed', error: row.error || error };
    }
    return row;
  });
  if (next.some((row) => row.status === 'failed')) return next;
  return [
    ...next,
    {
      id: 'stream-error',
      name: 'Operation failed',
      status: 'failed',
      error,
    },
  ];
}

export function describeStreamFailure(error: unknown): string {
  const message = error instanceof Error ? error.message : String(error || '');
  if (/\b401\b/i.test(message) || /unauthorized/i.test(message)) {
    return 'Session expired. Refresh the page, sign in, and try again.';
  }
  return message || 'Operation failed';
}
